import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState, type Dispatch, type SetStateAction } from "react";
import { toast } from "sonner";

export const useBrowseExplorations = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);

  const loadExplorations = async (
    setExplorations: Dispatch<
      SetStateAction<{
        explorations: any[];
        rotations: any[];
        sessions: any[];
        teachers: any[];
      }>
    >,
  ) => {
    try {
      setLoading(true);
      const response = await api(
        "/explorations?shape=student",
        { method: "GET" },
        dispatch,
      );
      setExplorations({
        explorations: response.explorations,
        rotations: response.rotations,
        sessions: response.sessions,
        teachers: response.teachers,
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { loadExplorations, loading };
};
